import React from 'react';
import { Link, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import '../styles/StorefrontPages.css';

const ARTICLES = {
  '1': {
    title: 'Рекомендации по приготовлению — хоспер и гриль',
    subtitle: 'Как раскрыть вкус мраморной говядины на открытом огне',
    body: [
      'Чтобы насладиться вкусом мраморной говядины, важно соблюдать несколько правил. Главное — правильно подготовить мясо и не торопиться с обжаркой.',
      '1. Размораживайте мясо медленно: только в холодильнике при +2…+6 °C, до полной оттайки (~двое суток). Никогда не используйте горячую воду или микроволновку — это разрушает структуру волокна. Потеря веса при разморозке составляет 3–7 %.',
      '2. Жарьте на очень высокой температуре. Поверхность стейка должна получить контакт не ниже 270 °C — это «закрытие» мяса: поры стягиваются, сахара карамелизуются и образуется та самая аппетитная корочка. Не важно, гриль это, хоспер или мангал.',
      '3. Не пренебрегайте отдыхом. После снятия с огня мясо должно полежать 3–5 минут — соки равномерно перераспределятся, и стейк станет сочным.',
    ],
    meta: { date: '12 мая 2026', read: '4 минуты чтения' },
  },
  '2': {
    title: 'Рекомендации по приготовлению — су-вид',
    subtitle: 'Метод низкотемпературной готовки: точность и предсказуемость',
    body: [
      'Sous-vide или су-вид — методика приготовления, которая в русскоязычной гастрономии воспринимается как нечто новое, но в европейской кухне она используется десятилетиями.',
      'Главное преимущество — полная предсказуемость результата. Вы задаёте температуру воды и время; мясо физически не может «пережариться», потому что не выходит за установленную температуру.',
      'Этот метод особенно хорош для отрубов с плотной структурой: голяшка, лопатка, грудинка — за 12–48 часов они превращаются в очень нежное и сочное мясо без потери формы.',
    ],
    meta: { date: '8 мая 2026', read: '6 минут чтения' },
  },
};

const ArticlePage = () => {
  const { articleId } = useParams();
  const article = ARTICLES[String(articleId)] || ARTICLES['1'];

  return (
    <div className="sfpage sfpage--narrow">
      <Link to="/" className="sfpage__back">
        <ArrowBackIcon fontSize="small" /> Назад в блог
      </Link>

      <header className="sfarticle__head">
        <span className="sfpage__eyebrow">Статья</span>
        <h1 className="sfarticle__title">{article.title}</h1>
        <p className="sfarticle__subtitle">{article.subtitle}</p>
        <div className="sfarticle__meta">
          <span>{article.meta.date}</span>
          <span className="sfarticle__dot">•</span>
          <span>{article.meta.read}</span>
        </div>
      </header>

      <article className="sfarticle__body">
        {article.body.map((p, i) => <p key={i}>{p}</p>)}
      </article>

      <div className="sfpage__cta">
        <div>
          <h3 className="sfpage__cta-title">Хотите попробовать?</h3>
          <p className="sfpage__cta-text">Закажите фермерскую мраморную говядину MB4 — доставим в день обращения.</p>
        </div>
        <Link to="/contact" className="sfpage__cta-btn">Связаться с нами</Link>
      </div>
    </div>
  );
};

export default ArticlePage;
